import React from 'react';
import { Button } from '@xpertdox_js/xdcomponents';
import { UserContext } from '../../Context/UserContext';
import styles from './styles';
import { trackActivity } from '../../utils/activityTracker'
import { InstanceContext } from '../../InstanceContext'
import instances from '../../config/instances'

const Instances = props => {
  const { user, userAction } = React.useContext(UserContext)
  const { contextInstance, updateContextInstance } = React.useContext(InstanceContext)

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  const handleInstanceSelect = (val) => {
    handleActivityLogUpdate(`Navbar.handleInstanceSelect.(${val})`)
    updateContextInstance({type: 'updateInstance', instance: val});
    userAction({ type: 'updateUser', property: 'instance', value: val})
    props.history.push('/')
    setTimeout(() => props.history.push(`/${val}/`, {title: 'XpertConsole'}))
  }

  return(
    <div>
      <ul style={{...styles.list}}>
        {instances.map((value, i) => {
          const currentInstance = props.instance
            ? value[props.instance]
            : value
          return(
            <li key={value[0]} style={{...styles.listItem, padding: 0}}>
              <Button
                styles={styles.link}
                hoverStyles={styles.linkHov}
                onClick={handleInstanceSelect}
                clickParam={value}
              >
                <span style={styles.linkText}>{ currentInstance }</span>
              </Button>
            </li>
          );
        })}
      </ul>
    </div>
  )
}

export default Instances;
